import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  notchedOutline: {
    borderRadius: '25px',
  },
}));

export default useStyles;
